import React, { useState, useEffect } from "react";
import AdminWrapper from "../AdminWrapper";
import SwitchMenuBar from "../../../Components/SwitchMenuBar/SwitchMenuBar";
import { morningSummary,morningTable } from "../../Statistics/statisticsTable";
import { API } from "../../../API";
import { StylesStatistics } from "../../Statistics/styled";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import {Refresh} from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';
import Modal from "../../../Components/Modal/Modal";
import moment from "moment";

const MorningET = () => {
  const [morningETData, setmorningETData] = useState({});
  const [morningETsummary, setmorningETsummary] = useState({});
  const [loading, setloading] = useState(false);
  const [modal,setmodal] = useState(false)
  const [date,setdate] = useState('')
  const [tableData,settableData] = useState({})
  const [state,setstate] = useState('')


  useEffect(() => {
    getmorningET();
  }, []);

  const getmorningET = async () => {
    try {
      setloading(true)
      const { data } = await API.morningET();
      const formattedDate = moment(data.data.summary.Date).format('DD MMM YYYY');
      setdate(formattedDate)
      let summarybyState = {}
      for(let state in data.data){
        if(state != 'summary'){
          if(!data.data[state]){data.data[state] = {}}
          summarybyState[state] = [
            data.data[state].filter(obj => obj.type === 'ELICOS' || obj.type === 'VET/ELICOS').length,
            data.data[state].filter(obj => obj.type === 'VET' || obj.type === 'VET/ELICOS').length,
            data.data[state].filter(obj => obj.type === 'ECEC').length
          ]
        }
      }
      data.data.summary.summarybyState = summarybyState
      setmorningETsummary(data.data.summary)
      morningData(data.data)
      setloading(false)
    } catch (error) {
      console.log('getmorningET ERR', error);
    }
  };
  const select = (state) =>{
    let data = morningETData[state]
    settableData(data)
    setstate(state)
  }
  const morningData = (data)=>{
    delete data.summary
    setmorningETData(data);
  }
  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <StylesStatistics>
      <div className="body-main-page-JobList">
        <div className="d-flex flex-col items-center my-2">
          <p className="text-3xl font-bold mb-2">MorningET Report</p>
          <p className="text-2xl font-bold">{date}</p>
        </div>
        <div className="d-flex flex-row overflow-auto collapse-check-buttons justify-between">
          <button 
          id="refresh"
          onClick={() => getmorningET()}
          className="refresh-button"
          >
          {loading ? <CircularProgress size={20} color="inherit"/> : <Refresh sx={{ color: "#000" }} />}
          </button>
        </div>
        <div className="row">
          <div 
            id='bookTable'
            className="col statistic-card">
          {morningSummary(morningETsummary,select,state)}
          </div>
        </div>
        <div className="row">
          <div 
            id='bookTable'
            className="col statistic-card">
          {morningTable(tableData)}
          </div>
        </div>
      </div>
      </StylesStatistics>
    </AdminWrapper>
  );
};

export default MorningET;
